module.exports = " <label class=btn v-bind:class=\"{\n  'active':checked,\n  'btn-success':type == 'success',\n  'btn-warning':type == 'warning',\n  'btn-info':type == 'info',\n  'btn-danger':type == 'danger',\n  'btn-default':type == 'default',\n  'btn-primary':type == 'primary'\n}\"> <input type=checkbox autocomplete=off :checked=checked @click=handleClick /> <slot></slot> </label> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./bootsets/components/vue-strap/checkboxBtn.vue
// module id = 264
// module chunks = 0